// @generated by liquid-inject from src/sections/filter-collection/filter-collection.ts
// src/shared/utils/section-render.ts
var SECTION_PREFIX = "shopify-section-";
function buildUrl(base, params) {
  const url = new URL(base ?? window.location.pathname, window.location.origin);
  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value);
  }
  return url.toString();
}
function withQuery(params, query) {
  if (!query) return params;
  const extra = Object.fromEntries(
    Object.entries(query).map(([k, v]) => [k, String(v)])
  );
  return { ...extra, ...params };
}
async function fetchSections(ids, options = {}) {
  const url = buildUrl(
    options.url,
    withQuery({ sections: ids.join(",") }, options.query)
  );
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
  return response.json();
}
function swapInner(html, selector) {
  const selectors = Array.isArray(selector) ? selector : [selector];
  const doc = new DOMParser().parseFromString(html, "text/html");
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((element) => {
      const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
      if (source) element.innerHTML = source.innerHTML;
    });
  });
}
function swapSection(id, html) {
  const live = document.getElementById(`${SECTION_PREFIX}${id}`);
  if (!live) return;
  const doc = new DOMParser().parseFromString(html, "text/html");
  const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
  if (next instanceof HTMLElement) {
    live.replaceWith(next);
  } else {
    live.hidden = true;
  }
}
async function renderSections(targets, options = {}) {
  if (targets.length === 0) return;
  const map = options.sections ?? await fetchSections(
    targets.map((t) => t.id),
    options
  );
  for (const target of targets) {
    const html = map[target.id];
    if (typeof html !== "string") continue;
    if (target.selector) {
      swapInner(html, target.selector);
    } else {
      swapSection(target.id, html);
    }
  }
}

// src/sections/filter-collection/filter-collection.ts
var GRID_PARAM = "grid";
function currentGridParam() {
  return new URLSearchParams(window.location.search).get(GRID_PARAM);
}
var Tfilter = class extends HTMLElement {
  /**
   * @constructor
   * Initialise les propriétés du composant
   */
  constructor() {
    super();
    this.allNextPageProduct = [];
    this.btnSectionFilterDeslectAll = [];
    this.btnSectionFilterSelectAll = [];
    this.btnToggleFilter = [];
    this.collection = null;
    this.dialog = null;
    this.filterActive = [];
    this.form = null;
    this.sectionsRender = [];
    this.initializeElements();
    this.initializeSections();
    this.handleEscape = this.handleEscape.bind(this);
    this.eventChangeForm = this.eventChangeForm.bind(this);
  }
  /**
   * Initialise les éléments DOM du composant
   * @private
   */
  initializeElements() {
    this.dialog = this.querySelector("[data-filter-dialog]");
    this.form = this.querySelector("form#form-filter");
    this.btnToggleFilter = Array.from(
      this.querySelectorAll("[data-btn-toggle-filter]")
    );
    this.filterActive = Array.from(
      this.querySelectorAll("[data-filter-active]")
    );
    this.btnSectionFilterSelectAll = Array.from(
      this.querySelectorAll("[data-filter-select]")
    );
    this.btnSectionFilterDeslectAll = Array.from(
      this.querySelectorAll("[data-filter-remove]")
    );
    this.allNextPageProduct = [
      ...document.querySelectorAll(".collection-grid--next")
    ];
    this.collection = document.querySelector("t-collection");
  }
  /**
   * Re-rend les sections de résultats pour l'URL courante.
   *
   * `main-collection` et `main-search` partent désormais dans une seule requête
   * `?sections=a,b` : une page n'en porte jamais qu'une, mais la demander à
   * l'aveugle est ce que faisait déjà le module legacy — en deux allers-retours
   * au lieu d'un.
   *
   * L'URL a déjà été poussée dans l'historique par l'appelant. En cas d'échec,
   * garder l'ancienne grille sous la nouvelle URL serait incohérent : on
   * recharge, comme le faisait le legacy en interne.
   */
  async renderFilteredSections(url) {
    try {
      await renderSections(this.sectionsRender, { url });
    } catch (error) {
      console.error("[Tfilter] section render failed:", error);
      window.location.reload();
    }
  }
  /**
   * Initialise la configuration des sections
   * @private
   */
  initializeSections() {
    this.sectionsRender = [
      {
        id: "main-collection",
        selector: [
          "[data-btn-apply-filter]",
          "[data-inputs-filter]",
          "[data-filter-tag]",
          "[data-grid-collection]",
          "[data-legend-filter]",
          "[data-legend-sortby]",
          "[data-product-count]",
          "collection-grid--next",
          "[data-rerender-more]"
        ]
      },
      {
        id: "main-search",
        selector: [
          "[data-btn-apply-filter]",
          "[data-inputs-filter]",
          "[data-filter-tag]",
          "[data-grid-collection]",
          "[data-legend-filter]",
          "[data-legend-sortby]",
          "[data-product-count]",
          "collection-grid--next",
          "[data-rerender-more]"
        ]
      }
    ];
  }
  /**
   * Callback appelé lorsque l'élément est connecté au DOM
   */
  connectedCallback() {
    this.setupEventListeners();
  }
  /**
   * Configure les écouteurs d'événements initiaux
   * @private
   */
  setupEventListeners() {
    this.toggleFilter();
    this.backDropClose();
    this.escapeClose();
    this.form?.addEventListener("change", this.eventChangeForm);
    this.form?.addEventListener("submit", (event) => {
      event.preventDefault();
      this.toggleDialogState();
    });
    if (this.btnSectionFilterSelectAll.length > 0) {
      this.addEventSectionFilterSelectAll();
    }
    if (this.btnSectionFilterDeslectAll.length > 0) {
      this.addEventSectionFilterDeslectAll();
    }
    this.addEventDeselectFiltersLink();
  }
  /**
   * Adds event listener to deselect all filters link
   * @private
   */
  addEventDeselectFiltersLink() {
    const deselectLink = this.querySelector(
      "[data-deselect-filters-link]"
    );
    if (deselectLink !== null) {
      deselectLink.addEventListener("click", (event) => {
        event.preventDefault();
        const url = new URL(window.location.href);
        const qParam = url.searchParams.get("q");
        const gridParam = url.searchParams.get(GRID_PARAM);
        url.search = "";
        if (qParam) {
          url.searchParams.set("q", qParam);
        }
        if (gridParam) {
          url.searchParams.set(GRID_PARAM, gridParam);
        }
        history.pushState("", "", url.href);
        this.renderFilteredSections(url);
        this.reSelectFilterActive();
        this.reselectBtnSectionFilterDeselectAll();
      });
    }
  }
  /**
   * Callback appelé lorsque l'élément est déconnecté du DOM
   */
  disconnectedCallback() {
    this.cleanup();
  }
  /**
   * Nettoie les écouteurs d'événements
   * @private
   */
  cleanup() {
    this.removeEventFilterActive();
    this.removeEventSectionFilterDeslectAll();
    this.form?.removeEventListener("change", this.eventChangeForm);
    window.removeEventListener("keydown", this.handleEscape);
  }
  /**
   * Gère la fermeture du dialogue via la touche Echap
   * @private
   */
  escapeClose() {
    window.addEventListener("keydown", this.handleEscape);
  }
  /**
   * Action à effectuer lors de l'appui sur Echap
   * @param {KeyboardEvent} event
   * @private
   */
  handleEscape(event) {
    if (event.key !== "Escape") return;
    if (!this.dialog?.open) return;
    event.preventDefault();
    this.toggleDialogState();
  }
  /**
   * Gère la fermeture du dialogue via le backdrop
   * @private
   */
  backDropClose() {
    this.dialog?.addEventListener("click", (event) => {
      if (!this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      const isInDialog = this.isClickInDialog(event, rect);
      if (!isInDialog) {
        this.toggleDialogState();
      }
    });
  }
  /**
   * Vérifie si un clic est à l'intérieur du dialogue
   * @param {MouseEvent} event - L'événement de clic
   * @param {DOMRect} rect - Les dimensions du dialogue
   * @returns {boolean}
   * @private
   */
  isClickInDialog(event, rect) {
    return rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
  }
  /**
   * Gère l'affichage/masquage du filtre
   * @private
   */
  toggleFilter() {
    this.btnToggleFilter?.forEach((btn) => {
      btn.addEventListener("click", () => this.toggleDialogState());
    });
  }
  /**
   * Bascule l'état du dialogue (ouvert/fermé)
   * @private
   */
  toggleDialogState() {
    if (!this.dialog) return;
    const dialog = this.dialog;
    if (dialog.open) {
      document.documentElement.classList.remove("is-overflow-hidden");
      dialog.close();
    } else {
      document.documentElement.classList.add("is-overflow-hidden");
      dialog.showModal();
    }
  }
  /**
   * Ajoute les écouteurs d'événements aux filtres actifs
   * @private
   */
  addEventFilterActive() {
    this.filterActive.forEach((filter) => {
      filter.addEventListener("click", () => this.removeFilterActive(filter));
    });
  }
  /**
   * Supprime les écouteurs d'événements des filtres actifs
   * @private
   */
  removeEventFilterActive() {
    this.filterActive.forEach((filter) => {
      filter.removeEventListener("click", () => this.removeFilterActive(filter));
    });
  }
  /**
   * Met à jour la sélection des filtres actifs
   * @private
   */
  reSelectFilterActive() {
    this.filterActive = Array.from(
      this.querySelectorAll("[data-filter-active]")
    );
    if (this.filterActive.length > 0) {
      this.removeEventFilterActive();
      this.addEventFilterActive();
    }
  }
  /**
   * Supprime un filtre actif
   * @param {HTMLElement} filter - L'élément filtre à supprimer
   * @private
   */
  async removeFilterActive(filter) {
    if (!filter.dataset.filterActive) return;
    history.pushState("", "", filter.dataset.filterActive);
    const url = new URL(window.location.href);
    await this.renderFilteredSections(url);
    this.reSelectFilterActive();
    this.addEventDeselectFiltersLink();
  }
  /**
   * Gère les changements du formulaire
   * @private
   */
  async eventChangeForm() {
    if (!this.form) return;
    const searchParams = this.createSearchParams(this.form);
    const params = new URLSearchParams(window.location.search);
    const gridParam = currentGridParam();
    const parts = [];
    if (params.has("q")) parts.push(`q=${params.get("q")}`);
    if (searchParams) parts.push(String(searchParams));
    if (gridParam) parts.push(`${GRID_PARAM}=${gridParam}`);
    const newUrl = `${window.location.pathname}${parts.length ? `?${parts.join("&")}` : ""}`;
    history.pushState({ searchParams }, "", newUrl);
    const url = new URL(window.location.href);
    await this.renderFilteredSections(url);
    this.reRenderBtnmore();
    this.reSelectFilterActive();
    this.reselectBtnSectionFilterDeselectAll();
    this.addEventDeselectFiltersLink();
  }
  reRenderBtnmore() {
    if (!this.collection) return;
    this.collection.dataset.reRender = "true";
    this.allNextPageProduct.forEach((el) => el.classList.remove("is-active"));
  }
  /**
   * Crée les paramètres de recherche à partir du formulaire
   * @param {HTMLFormElement} form - Le formulaire à traiter
   * @returns {string}
   * @private
   */
  createSearchParams(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (typeof value === "string") {
        params.append(key, value);
      }
    });
    return params.toString();
  }
  /**
   * Met à jour les boutons de désélection des sections de filtres
   * @private
   */
  reselectBtnSectionFilterDeselectAll() {
    this.btnSectionFilterSelectAll = Array.from(
      this.querySelectorAll("[data-filter-select]")
    );
    this.btnSectionFilterDeslectAll = Array.from(
      this.querySelectorAll("[data-filter-remove]")
    );
    if (this.btnSectionFilterSelectAll.length > 0) {
      this.addEventSectionFilterSelectAll();
    }
    if (this.btnSectionFilterDeslectAll.length > 0) {
      this.removeEventSectionFilterDeslectAll();
      this.addEventSectionFilterDeslectAll();
    }
  }
  addEventSectionFilterSelectAll() {
    this.btnSectionFilterSelectAll.forEach((filter) => {
      filter.addEventListener("click", () => this.selectSectionFilter(filter));
    });
  }
  /**
   * Ajoute les écouteurs d'événements aux boutons de désélection des sections
   * @private
   */
  addEventSectionFilterDeslectAll() {
    this.btnSectionFilterDeslectAll.forEach((filter) => {
      filter.addEventListener("click", () => this.removeSectionFilter(filter));
    });
  }
  /**
   * Supprime les écouteurs d'événements des boutons de désélection des sections
   * @private
   */
  removeEventSectionFilterDeslectAll() {
    this.btnSectionFilterDeslectAll.forEach((filter) => {
      filter.removeEventListener(
        "click",
        () => this.removeSectionFilter(filter)
      );
    });
  }
  async selectSectionFilter(filter) {
    const url = new URL(window.location.href);
    const list = filter.closest("ul");
    if (!list) return;
    const checkboxes = Array.from(
      list.querySelectorAll(
        'input[type="checkbox"]:not([disabled])'
      )
    );
    checkboxes.forEach((checkbox) => {
      const paramName = checkbox.getAttribute("name");
      const paramValue = checkbox.getAttribute("value");
      if (!paramName || paramValue === null) return;
      url.searchParams.append(paramName, paramValue);
    });
    history.pushState("", "", url.href);
    await this.renderFilteredSections(url);
    this.reSelectFilterActive();
    this.reselectBtnSectionFilterDeselectAll();
    this.addEventDeselectFiltersLink();
  }
  /**
   * Supprime un filtre de section
   * @param {HTMLElement} filter - L'élément filtre à supprimer
   * @private
   */
  async removeSectionFilter(filter) {
    const url = new URL(window.location.href);
    const filterName = filter.dataset.filterRemove;
    if (!filterName) return;
    url.searchParams.delete(filterName);
    history.pushState("", "", url.href);
    await this.renderFilteredSections(url);
    this.reSelectFilterActive();
    this.reselectBtnSectionFilterDeselectAll();
    this.addEventDeselectFiltersLink();
  }
};
customElements.define("t-filter", Tfilter);
